export const translations = {
  en: {
    home: "Home",
    about: "About Us",
    menu: "Menu",
    restaurant: "Restaurant",
    foodTruck: "Food Truck",
    contact: "Contact Us",
    AliGroup:"Ali's Group",
     visit_alis_group: "Visit Ali's Group",
      dineWithUs: "Dine with us",
    findUsNearYou: "Find us near you",
    orderNow: "Order Now",
    our_expertise: "Our Expertise",
     years_experience: "Years Experience",
    client_retention: "Client Retention",
    global_investors: "Global Investors",
    eventEnquiry: "Reservation",
    cart: "Cart",
    signIn: "Sign In",
    searchPlaceholder: "Search products...",
    shopByCategories: "Shop By Categories",
    ourRestaurants: "Ali's Kebab Near You",
    discoverText:
      "Discover Ali's Kebab restaurants and food trucks near you. Enjoy authentic halal kebabs, Persian, Middle Eastern, and Indian cuisine prepared fresh daily.",
    ourFoodTruck: "Our Food Truck",
    discoverFoodTruck:
      "Discover nearby food trucks and restaurants serving your favorite dishes.",
    mapView: "Map View",
    restaurants: "Restaurants",
    discoverTitle: "Discover Ali’s Kebab restaurants near you",
    discoverDesc:
      "Find locations, browse menus, and enjoy fresh halal Persian, Middle Eastern, and Indian cuisine made daily.",
    email: "Email",
    foodTruckTitle:
      "Authentic Ali’s Kebab Food Trucks – Serving Across the Kanto Region",
    foodTruckDesc:
      "Bring the authentic taste of Ali’s Kebab to your next event.Catering packages start from ¥80,000 (weekdays) and ¥100,000 (weekends/holidays), including service for 100 kebab sandwiches or more. Additional fees may apply depending on location and venue.We offer flexible menus and order quantities tailored to your budget and event needs, delivering authentic halal cuisine and professional service for any occasion.",
    ourFoodTrucks: "Our Food Trucks",
    searchFood: "Search Names and Venues",
    zipCode: "Zip Code",
    noFoodTruck: "No food trucks found.",
    title: "Ali's Kebab Authentic Taste Closer to You",
    desc: "Ali’s Kebab uses premium halal ingredients and traditional cooking methods to serve authentic Persian, Middle Eastern, and Indian cuisine with rich flavors.",
    category: "Category",
    showMore: "Show More",
    showLess: "Show Less",
    noMenuItems: "No menu items found",
    mealType: "Meal Type",
    meals: {
      breakfast: "Breakfast",
      lunch: "Lunch",
      dinner: "Dinner",
      snacks: "Snacks",
    },
    aboutRestaurant: "About Restaurant",
    allCategories: "All Categories",
    downloadMenu: "Download Menu",
    restaurantInfo: "Restaurant Info",
    openingHours: "Opening Hours",
    phone: "Phone",
    capacity: "Capacity",
    parking: "Parking",
    people: "people",
    cars: "Cars",
    feelFreeText:
      "Please feel free to use it for parties, celebrations, New Year's parties, etc.",
    tableReservation: "Table Reservation",
    foodTruckHeading: "Kebabs That Travel With You",
    foodTruckDescription:
      "Find our food truck near you and enjoy freshly prepared, flavorful meals wherever you are. Whether we’re parked in your neighborhood, at a local event, or on a busy city street, our mobile kitchen brings the authentic taste of Aries Kebab right to your doorstep.",
    estimateDeliveryTime: "Estimate Delivery Time",
    description: "Description",
    youMayAlsoLike: "You May Also Like",
    discoverNearby:
      "Discover nearby food trucks and restaurants serving your favorite dishes.",
    addToCart: "Add To Cart",
    AddedToCart: "Added To Cart",
    AddMoreItem: "Add More Item",
    Description: "Description",
    genuine: "100% Fresh",
    products: "Ingredients",
    certified: "Quality",
    installation: "Food",
    secure: "Hygienic",
    payment: "Centric ",
    easy: "Authentic",
    returns: "Taste",
    qty: "Qty",
    freshFastDelivery: "Kebab Means Ali's Kebab",
    heroTitle: "Ali's Kebab",
    heroDescription:
      "Serves various cuisine. Authentic Persian and Middle Eastern.",
    addNotes: "Add notes (allergies, preferences, etc.)",
    specialInstructions: "Special Instructions",
    shoppingCart: "Shopping Cart",
    close: "Close",
    yourCartIsEmpty: "Your cart is empty",
    subtotal: "Subtotal",
    viewCart: "View Cart",
    checkout: "Checkout",
    addedToCart: "Added to cart",
    product: "Product",
    addMoreItems: "Add More Items",
    orderSummary: "Order Summary",
    useCurrentLocation: "Use my current location",
    enterZipCode: "Enter your ZIP code",
    welcomeBack: "Hi, Welcome Back!",
    signInAccess: "Sign in to access your account and opportunities.",
    enterEmail: "Enter your email address",
    enterOtp: "Enter OTP",
    resendOtpIn: "Resend OTP in",
    resending: "Resending",
    resendOtp: "Resend OTP",
    signingIn: "Signing In",
    orSignInWith: "or Sign In with",
    line: "LINE",
    google: "Google",
    Bento: "Obento",
    Searching: "Searching...",
    BirthdayParty: "Birthday Party",
    FamilyDinner: "Family Dinner",
    Other: "Other",
    Delivery: "Delivery",
    Catering: "Catering",
    Banner: {
      heading: "Catch the Ali’s Kebab Food Truck Near You!",
      description:
        "Craving authentic street food? Follow Ali’s Kebab food trucks as they travel through your neighborhood, serving sizzling, freshly prepared halal doner kebabs.We slice flame-grilled kebab meat fresh off the spit and wrap it with crisp vegetables for a quick, delicious takeaway.",
      description2:
        "Check our live schedule to find your nearest stop and enjoy hot, flavorful kebabs on the go—perfect for lunch, dinner, or a quick bite.",
      button: "Explore Nearby",
    },
    Discover: {
      Location: "Near Your Location",
      Local: "Discover Local",
      Favorites: "Favorites",
      description:
        " Over 50+ restaurants and food trucks in your neighborhood ready to serve you fresh, delicious meals.",
      button: "Explore Nearby",
    },

    AboutSection: {
      title: "Ali’s Kebab",
      description1:
        "Ali’s Kebab started in 1997 with one food truck in Japan. Today we serve authentic halal Persian kebabs, Mediterranean specialties, and Indian cuisine across restaurants and food trucks.",
      description2:
        "Aries Kebab's management philosophy is to provide delicious food and satisfaction to our customers, and we aim to be a friendly company with strong local ties.",
      process1Title: "Select Restaurant/Truck",
      process1Description:
        "Choose from nearby restaurants and food trucks based on your location, & availability.",
      process2Title: "Select menu",
      process2Description:
        "Browse menus, customize your order, and add your favorite dishes to the cart with ease.",
      process3Title: "Wait for delivery",
      process3Description:
        "Sit back and relax while your food is freshly prepared and delivered to your doorstep.",
    },
    FooterContact: {
      heading: "See the best restaurants and food trucks near you",
      restaurantButton: "Find Restaurants",
      foodTruckButton: "Find Food Truck",
      description: "All of our dishes are halal and certified Muslim-friendly.",
      socialHeading: "Connect on Social Media",
      quickLinksHeading: "Quick Links",
      liveSupport: "Need Live Support?",
      copyright:
        "Copyright © 1997 Ali's Group Co. Ltd. (Ali's Kebab), all rights reserved.",
      poweredBy: "Powered by:",
      newsletterLabel: "Sign up for Newsletter",
      newsletterPlaceholder: "Enter your email",
      subscribeButton: "Subscribe",
    },
    BusinessInfo: {
      heading: "Business Info",
      companyNameLabel: "Company Name:",
      brandNameLabel: "Brand Name:",
      telLabel: "TEL:",
      faxLabel: "FAX:",
      establishedLabel: "Established:",
      representativeLabel: "Representative:",
      addressLabel: "Address:",
      BusinessContent: "Business content",
      LoadMore: "Load More",
    },
    RecruitmentContent: {
      heading: "Recruitment Information",
      desc: "Mail us for job inquiries to discuss open positions",
      jobOpenings: "Job Openings",
      outletLabel: "Outlet",
      workPlaceLabel: "Work place",
      requiredQualificationsLabel: "Required qualifications",
      contactInformationLabel: "Contact information",
      noJobMessage: "No job available",
      onlineOrderingUnavailable:
        "Online ordering is currently unavailable for this restaurant. Orders are accepted until 30 minutes before closing time.",
    },
    added: "Added",
    CateringContent: "Catering Services",
    DeliveryServiceContent: {
      heading: "Delivery Partners",
      description:
        "",
      orderFrom: "Order from",
      notFound: "Not Found!",
      note1: "This link will take you to an external website.",
      note2:
        "Please check the linked page for participating stores, hours, etc.",
      note3: "Photos and illustrations are for illustrative purposes only.",
      note4: "Containers and packaging may differ when served.",
      note5: "Menus, set contents, and prices may vary depending on the store.",
    },

    BoothApplicationContent: {
      heading: "Vendor Registration Form",
      namePlaceholder: "Your Name",
      emailPlaceholder: "Your Email",
      phonePlaceholder: "Your Phone",
      placePlaceholder: "Place",
      numberOfPeoplePlaceholder: "Number of people",
      messagePlaceholder: "Any dietary requirements or special occasions...",
      note1:
        "Depending on your budget and the scale of the event, we can flexibly adjust the menu items and the number of servings provided.",
      note2:
        "If you are considering kebab sandwiches, food truck services, catering, or event stalls, please feel free to contact us.",
      note3: "We will propose the most suitable plan according to your needs and requirements.",
      note4:
        "The service fee starts from ¥100,000 within Ibaraki Prefecture. Additional booth fees and transportation costs will apply for events outside the prefecture.",
      note5:
        "Reservations are accepted from one month in advance.",
      submitting: "Submitting...",
      submitRequest: "Submit Request",
    },
    Closedon: "Closed on",
    onlineOrderingClosed: "Online ordering is currently closed for",
    lastOrderMessage:
      "Last orders are accepted 30 minutes before closing time.",
    OnlineOrderingClosed: "Online Ordering Closed",
    clearCart: "Clear Cart",
    loading: "Loading...",
    ContactUsContent: {
      heading: "Reach out anytime, our team is ready",
      description:
        "Whether you have questions, need support, or want to explore how we can work together, our team is always here to assist you. We’re committed to providing quick responses and reliable guidance to ensure your needs are met without delay.",
      phoneLabel: "Phone",
      emailLabel: "EMAIL",
      addressLabel: "ADDRESS",
      formHeading: "Get In Touch",
      formDescription:
        "Connect with us today to discuss your needs and discover how we can create the right solutions for you.",
      namePlaceholder: "Your Name",
      emailPlaceholder: "Your Email",
      phonePlaceholder: "Your Phone",
      subjectPlaceholder: "Your Subject",
      messagePlaceholder: "Write your message here",
      submitting: "Submitting...",
      submitRequest: "Submit Request",
      Getintouch: "Get in touch",
      address:"1-2-20 Nishine Nishi, Tsuchiura City, Ibaraki Prefecture, 300-0848"
    },

    EventEnquiryContent: {
      heading: "Event Enquiry",
      description:
        "Plan your event with ease. Share your requirements, and our team will help you customize the perfect food experience.",
      restaurantLabel: "Restaurant",
      selectRestaurant: "Select Restaurant",
      nameLabel: "Name",
      namePlaceholder: "Enter Your Name",
      phoneLabel: "Phone",
      phonePlaceholder: "Enter Your Phone Number",
      selectDateLabel: "Select Date",
      selectTimeLabel: "Select Time",
      numberOfGuestLabel: "Number of Guest",
      specialRequestsLabel: "Special Requests (Optional)",
      specialRequestsPlaceholder:
        "Any dietary requirements or special occasions...",
      submitting: "Submitting...",
      submitEnquiry: "Submit Enquiry",
      emailLabel: "Email",
      emailPlaceholder: "Enter Your Email",
      selectTableLabel: "Select Table",
  selectTablePlaceholder: "-- Select a table --",
  loadingTables: "Loading tables...",
  noSlotAvailable: "No slot available",
    },
    ReserveTableContent: {
      heading: "Reserve Your Table",
      description1: "Book a table at your favorite restaurant. Pay only",
      description2:
        "as token in advance, which will be adjusted in your final bill.",
      booking: "Booking...",
      confirmBooking: "Confirm Booking",
    },
    LoginContent: {
      heading: "Welcome to",
      brandName: "Ali’s Kebab",
      subHeading: "We are ready to provide you",
      feature1: "Secure & encrypted sign-in",
      feature2: "Quick access to your dashboard",
      feature3: "Premium Quality Food & Kebab",
    },

    CartPageContent: {
      applyCoupon: "Apply Coupon",
      enterCouponCode: "Enter coupon code",
      remove: "Remove",
      apply: "Apply",
      availableCoupons: "Available Coupons",
      minCart: "Min cart:",
      expires: "Expires:",
      notApplicable: "Not Applicable",
      subtotal: "Subtotal",
      items: "items",
      dealsOffers: "Deals & offers",
      shipping: "Shipping",
      tax: "Tax",
      shippingTaxEstimated: "*Shipping & tax estimated in checkout",
      estimatedTotal: "Estimated total",
      proceedToCheckout: "Proceed To Checkout",
      payWithStripe: "Pay with Square",
      orderSummary: "Order summary",
      paymentOptions: "Payment Options",
      orderFromDeliveryPartner: "Order from Delivery Partner",
      minimumOrderForDelivery: "Minimum order for delivery:",
      pickup: "Pickup",
      delivery: "Delivery",
      orderType: "Order Type",
      orderrefund:" * Once ordered, the amount is non-refundable.",
    },

    CheckoutFormContent: {
      continueShopping: "Continue Shopping",
      emailInfo:
        "We'll use this email to send you details and updates about your order.",
      emailPlaceholder: "Enter your email address",
      guestCheckout: "You are currently checking out as a guest.",
      selectAddress: "Select Address",
      addressLabel: "Address:",
      billingAddress: "Billing address",
      yourDetails: "Your Details",
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      address: "Address",
      country: "Country",
      city: "City",
      state: "State",
      zipCode: "Zip Code",
      shippingAddress: "Shipping address",
      sameAsBilling: "Shipping address is the same as the billing address.",
      email: "Email",
      addNote: "Add Note",
      addNotePlaceholder: "Add a note to your order",
    },
    PaymentFailedContent: {
      title: "Payment Failed!",
      description: "Your payment could not be processed.",
      supportMessage: "Need help? Contact our support team at",
    },
    PaymentSucessContent: {
      payment_success: "Payment Success!",
      payment_success_msg:
        "Your payment has been processed successfully. You will receive a confirmation email shortly.",
      transaction_id: "Transaction ID",
      date: "Date",
      transaction_type: "Type of Transaction",
      status: "Status",
      success: "Success",
      total: "Total",
      receipt_sent: "Receipt sent to",
      download_receipt: "Download Receipt",
      downloading: "Downloading...",
      continue_shopping: "Continue Shopping",
      support_text: "Need help? Contact our support team at",
      date_time: "Date Time",
      restaurant: "Restaurant",
      table_no: "Table No",
      guests: "Guests",
       payment_pending_title: "Your payment is still processing",
        check_again: "Check Again",
  payment_pending_msg: "We'll update this page automatically, or check back shortly.",

  payment_failed_title: "Payment failed",
  payment_failed_msg: "Please try again.",
  back_to_menu: "Back to menu",

  payment_refunded_title: "Payment refunded",
  payment_refunded_msg: "This payment has been refunded.",

  confirming_payment: "Confirming your payment, please wait…",
  
    },
    my_profile: "My Profile",
    logout: "Logout",
    logout_confirm: "Are you sure you want to logout?",
    cancel: "Cancel",
    discover_food_title: "Discover Great Food Near You",
    discover_food_desc:
      "Explore our restaurants and food trucks across the city. Find the nearest location, browse menus, and enjoy delicious meals made fresh for you.",
    wishlist: "Wishlist",
    my_orders: "My Orders",
    my_details: "My Details",
    saving: "Saving...",
    save_changes: "Save Changes",
    select_title: "Select Title",
    enter_name: "Enter your name",
    enter_phone: "Enter your phone number",
    enter_email: "Enter your email address",
    delete_account: "Delete Account",
    delete_account_desc:
      "If you’ve decided that Ali’s Kebab is no longer the right place for you, you can delete your account by clicking the button below. Please note that account deletion is not possible if you currently have any active orders, pending payments, or ongoing delivery processes.",
    delete_account_title: "Delete Account?",
    delete_account_warning:
      "Your account will be permanently deleted. This action cannot be undone.",
    confirm_delete_account: "Yes, Delete My Account",
    no_wishlist_items: "No items in wishlist",
    bentotitle: "Delicious Halal Bento Variations",
    bentodes:
      "Premium Halal Bento featuring authentic Persian, Middle Eastern, and Indian cuisine with fresh doner kebab. Ideal for events, meetings, and catering with flexible customization options.",
    address: {
      my_address: "My Address",
      add_new_address: "Add New Address",
      loading: "Loading...",
      no_address_found: "No address found.",
      edit: "Edit",
      delete: "Delete",
      house_flat_number: "House / Flat Number",
      building_society_name: "Building / Society Name",
      city: "City",
      state: "State",
      pincode_zipcode: "Pincode / ZIP Code",
      add_new_address_title: "Add New Address",
      add_new_address_desc:
        "Please fill in the details below to add a new address to your profile. Make sure to provide accurate information for smooth deliveries and communication.",
      enter_name: "Enter your name",
      phone: "Phone",
      house_no: "House No",
      locality: "Locality",
      country: "Country",
      zip_code: "Zip Code",
      select_type: "Select Type",
      home: "Home",
      office: "Office",
      hotel: "Hotel",
      other: "Other",
      save_address: "Save Address",
      saving: "Saving...",
      title: "Are you sure?",
      text: "This address will be permanently deleted.",
      confirm_button: "Yes, delete it!",
      cancel_button: "Cancel",
    },
    OrderContent: {
      my_orders: "My Orders",
      search_food_restaurant: "Search food or restaurant...",
      zip_code: "Zip Code",
      search: "Search",
      loading_orders: "Loading orders...",
      no_orders_found: "No Orders Found",
      order_item: "Order Item",
      subtotal: "Subtotal",
      charges: "Charges",
      total: "Total",
      date_time: "Date & Time",
      order_status: "Order Status",
      discount: "Discount",
      tax: "Tax",
      shipping: "Shipping",
      more_item: "more item",
      base_price: "Base Price",
      qty: "Qty",
      rate_item: "⭐ Rate Item",
      prev: "← Prev",
      next: "Next →",
      rate_your_order: "Rate Your Order",
      item: "Item",
      share_experience: "Share your experience",
      poor: "😞 Poor",
      okay: "😐 Okay",
      good: "🙂 Good",
      very_good: "😊 Very Good",
      excellent: "😍 Excellent",
      share_experience_placeholder: "Share your experience...",
      submitting: "Submitting...",
      submit_review: "Submit Review",
    },
     OrderConfirmModal: {
      title: "Confirm Your Order",
      orderingFrom: "You are ordering from",
      locatedIn: "Which is located in",
      goBack: "Go Back",
    },
     seo: {
    home: {
      title: "Ali’s Kebab | Turkish & Persian Kebab | Order Online",
      description: "Order authentic Turkish and Persian kebabs online from Ali’s Kebab. Freshly prepared wraps, grilled dishes, pizza, and more. Fast takeaway and dine-in available.",
    },
    about: {
      title: "About Us | Ali's Kebab",
      description: "Learn more about Ali's Kebab and our story.",
    },

  },
  },

  jpn: {
    home: "ホーム",
    about: "アリーズケバブについて",
    menu: "メニュー",
    restaurant: "レストラン",
    foodTruck: "キッチンカー",
    contact: "お問い合わせ",
     AliGroup:"アリズ・グループ",
      visit_alis_group: "アリズ・グループを訪れる",
      dineWithUs: "店内でお召し上がりください",
    findUsNearYou: "近くのお店を探す",
    orderNow: "今すぐ注文",
    our_expertise: "私たちの専門分野",
     years_experience: "経験年数",
    client_retention: "顧客維持率",
    global_investors: "世界中の投資家",
    eventEnquiry: "予約",
    cart: "カート",
    signIn: "サインイン",
    searchPlaceholder: "商品を検索...",
    shopByCategories: "カテゴリー別に探す",
    ourRestaurants: "アリーズケバブ 店舗一覧",
    discoverText:
      "お近くのアリーズケバブ店舗やキッチンカーを検索。本格ハラールケバブ・ペルシャ料理・中東料理・インド料理を出来たてで楽しめます。最新の出店・店舗情報を掲載。",
    ourFoodTruck: "フードトラック一覧",
    discoverFoodTruck:
      "お近くのフードトラックやレストランでお好みの料理を見つけましょう。",
    mapView: "地図を見る",
    restaurants: "レストラン",
    discoverTitle: "アリーズケバブ店舗検索",
    discoverDesc:
      "アリーズケバブの店舗を検索して、できたてのハラール料理をお楽しみください。店舗情報やメニューもご確認いただけます。",
    email: "メール",
    foodTruckTitle: "本場の味アリーズケバブのキッチンカー 関東を中心に出店中",
    foodTruckDesc:
      "本場のハラールケバブを、日本各地のイベントやお祭りへお届けします。キッチンカーによる出店・ケータリングを承っており、100食から対応可能です。イベントの規模やご要望に合わせたプランをご提案いたしますので、お気軽にお問い合わせくださいませ。",
    ourFoodTrucks: "フードトラック一覧",
    searchFood: "名前や店舗を検索",
    zipCode: "郵便番号",
    noFoodTruck: "フードトラックが見つかりません。",
    title: "アリーズケバブ 本場の味をあなたの身近に",
    desc: "アリーズケバブは厳選ハラール食材とオリエンタルスパイスを使用し、伝統調理で仕上げた本格ペルシャ・中東・インド料理を提供しています。",
    category: "カテゴリー",
    showMore: "もっと見る",
    showLess: "閉じる",
    noMenuItems: "メニューが見つかりません",
    mealType: "食事タイプ",
    meals: {
      breakfast: "朝食",
      lunch: "昼食",
      dinner: "夕食",
      snacks: "軽食",
    },
    aboutRestaurant: "レストランについて",
    allCategories: "すべてのカテゴリ",
    downloadMenu: "メニューをダウンロード",
    restaurantInfo: "店舗情報",
    openingHours: "営業時間",
    phone: "電話番号",
    capacity: "収容人数",
    parking: "駐車場",
    people: "人",
    cars: "台",
    feelFreeText: "パーティーやお祝い、新年会などにぜひご利用ください。",
    tableReservation: "テーブル予約",
    foodTruckHeading: "あなたのもとへ届けるケバブ",
    foodTruckDescription:
      "お近くのフードトラックを見つけて、できたての美味しい料理をお楽しみください。私たちは、街中や地域のイベント、賑やかな通りなど、さまざまな場所に出店しています。移動式キッチンで、本格的なアリーズケバブの味をあなたのもとへお届けします。",
    estimateDeliveryTime: "お届け目安時間",
    description: "商品説明",
    youMayAlsoLike: "こちらもおすすめ",
    discoverNearby:
      "お近くのフードトラックやレストランで、お気に入りの料理を見つけましょう。",
    addToCart: "カートに追加",
    AddedToCart: "カートに追加されました",
    AddMoreItem: "さらにアイテムを追加",
    Description: "説明",
    genuine: "100％新鮮",
    products: "材料",
    certified: "品質",
    installation: "食べ物",
    secure: "衛生的",
    payment: "中心",
    easy: "本物",
    returns: "味",
    qty: "数量",
    freshFastDelivery: "ケバブといえば、アリーズケバブ",
    heroTitle: "アリーズケバブ",
    heroDescription:
      "本格的なペルシャ料理や中東料理をはじめ、多彩な料理をご提供しています。",
    addNotes: "メモを追加（アレルギー・ご希望など）",
    specialInstructions: "特別な指示",
    shoppingCart: "ショッピングカート",
    close: "閉じる",
    yourCartIsEmpty: "カートは空です",
    subtotal: "小計",
    viewCart: "カートを見る",
    checkout: "お会計へ進む",
    addedToCart: "カートに追加されました",
    product: "商品",
    addMoreItems: "さらに商品を追加",
    orderSummary: "注文概要",
    useCurrentLocation: "現在地を使用する",
    enterZipCode: "郵便番号を入力してください",
    welcomeBack: "おかえりなさい！",
    signInAccess: "サインインしてアカウントと機会にアクセスしてください。",
    enterEmail: "メールアドレスを入力してください",
    enterOtp: "OTPを入力してください",
    resendOtpIn: "OTPを再送するまで",
    resending: "再送中",
    resendOtp: "OTPを再送",
    signingIn: "サインイン中",
    orSignInWith: "または次の方法でサインイン",
    line: "LINE",
    google: "Google",
    Bento: "お弁当",
    Searching: "検索中...",
    BirthdayParty: "誕生日パーティー",
    FamilyDinner: "家族の夕食",
    Other: "他の",
    Delivery: "配達",
    Catering: "ケータリング",
    Banner: {
      heading: "あなたの近くにアリーズケバブのキッチンカーが登場！ ",
      description:
        "本格的なストリートフードをお探しですか？ アリーズケバブのキッチンカーがあなたの街を巡り、出来たてのハラールドネルケバブをお 届けします。ジューシーに焼き上げたケバブをその場でスライスし、新鮮な野菜とともに サンドしてご提供。手軽に楽しめる本場の味わいです。",
      description2:
        "最新の出店スケジュールをチェックの上、お近くの会場で出来たての美味しさを ぜひお楽しみください！ランチ・ディナーはもちろん軽食やお子様の補食にも最適です。",
      button: "近くを探索",
    },
    Discover: {
      Location: "あなたの近く",
      Local: "地元を発見",
      Favorites: "お気に入り",
      description:
        "あなたの地域には、50以上のレストランやフードトラックがあり、新鮮で美味しい料理を提供しています。",
      button: "近くを探索",
    },
    AboutSection: {
      title: "アリーズケバブ",
      description1:
        "1997年創業のアリーズケバブ。1台のキッチンカーから始まり、現在は日本全国でハラール対応の本格ペルシャケバブや地中海・インド料理を提供しています。",
      description2:
        "アリーズケバブの経営理念は、美味しい料理と満足をお客様に提供することです。地域とのつながりを大切にした親しみやすい会社を目指しています。",
      process1Title: "レストラン・トラックを選択",
      process1Description:
        "現在地や利用可能状況に基づいて、近くのレストランやフードトラックをお選びください。",
      process2Title: "メニューを選択",
      process2Description:
        "メニューを閲覧し、注文をカスタマイズして、お気に入りの料理を簡単にカートへ追加できます。",
      process3Title: "配達を待つ",
      process3Description:
        "料理が新鮮に調理され、ご自宅まで届けられるまで、ゆっくりお待ちください。",
    },
    FooterContact: {
      heading: "近くの美味しいのレストランやキッチンカーを見つけましょう",
      restaurantButton: "レストランを探す",
      foodTruckButton: "キッチンカーを探す",
      description: "ハラール対応・ムスリムフレンドリー認証取得店です。 ",
      socialHeading: "ソーシャルメディアでつながる",
      quickLinksHeading: "クイックリンク",
      liveSupport: "ライブサポートが必要ですか？",
      copyright:
        "Copyright © 1997 Ali's Group Co. Ltd.（Ali's Kebab）All rights reserved.",
      poweredBy: "提供元:",
      newsletterLabel: "ニュースレターに登録",
      newsletterPlaceholder: "メールアドレスを入力",
      subscribeButton: "登録する",
    },
    BusinessInfo: {
      heading: "会社情報",
      companyNameLabel: "会社名:",
      brandNameLabel: "ブランド名:",
      telLabel: "TEL:",
      faxLabel: "FAX:",
      establishedLabel: "設立:",
      representativeLabel: "代表者:",
      addressLabel: "住所:",
      BusinessContent: "事業内容 ",
      LoadMore: "もっと読み込む",
    },
    RecruitmentContent: {
      heading: "採用情報",
      desc: "求人に関するお問い合わせや募集職種については、メールにてお気軽にご連絡ください。",
      jobOpenings: "求人募集",
      outletLabel: "店舗",
      workPlaceLabel: "勤務地",
      requiredQualificationsLabel: "応募資格",
      contactInformationLabel: "連絡先",
      noJobMessage: "現在、求人はありません",
      onlineOrderingUnavailable:
        "現在、このレストランではオンライン注文をご利用いただけません。ご注文は閉店時間の30分前まで受け付けています。",
    },
    CateringContent: "キッチンカー ケータリングサービス",
    added: "追加されました",
    DeliveryServiceContent: {
      heading: "デリバリーパートナー ",
      description:
        "",
      orderFrom: "こちらから注文",
      notFound: "見つかりませんでした！",
      note1: "このリンクをクリックすると外部サイトへ移動します。",
      note2:
        "対象店舗や営業時間などの詳細は、リンク先のページをご確認ください。",
      note3: "写真やイラストはイメージです。",
      note4: "提供時には容器や包装が異なる場合があります。",
      note5:
        "メニュー内容、セット内容、価格は店舗によって異なる場合があります。",
    },

    BoothApplicationContent: {
      heading: "お問合せフォーム",
      namePlaceholder: "お名前",
      emailPlaceholder: "メールアドレス",
      phonePlaceholder: "電話番号",
      placePlaceholder: "場所",
      numberOfPeoplePlaceholder: "人数",
      messagePlaceholder: "食事制限や特別なご要望があればご記入ください。",
      note1:
        "ご予算やイベント規模に応じて、メニュー内容や提供数を柔軟に調整可能です。",
      note2:
        " ケバブサンド、キッチンカー出店、ケータリング、イベント出店をご検討の際は、お気軽にご相談ください。",
          note3: "お客様のご要望に合わせた最適なプランをご提案いたします。",
      note4:
        "購入料金は10万円～(茨城県内)となります。※他県は出店料・交通費がかかります",
      note5:
        "ご予約は1ケ月前から受け付けています。",
      submitting: "送信中...",
      submitRequest: "リクエストを送信",
    },
    Closedon: "定休日",
    onlineOrderingClosed: "現在、オンライン注文は受付終了しています：",
    lastOrderMessage: "ラストオーダーは閉店時間の30分前まで受け付けています。",
    OnlineOrderingClosed: "オンライン注文受付は終了しました。",
    clearCart: "カートを空にする",
    loading: "読み込み中...",

    ContactUsContent: {
      heading: "お気軽にご相談・お問い合わせください",
      description:
        "キッチンカー出店、ケータリング、ハラール弁当のご注文、イベント出店に関するご相談 お見積り依頼は、お気軽にお問い合わせください。 アリーズケバブでは、お客様のご要望やイベント規模に合わせた最適なプランをご提案いたします。迅速かつ丁寧な対応で、安心してご利用いただけるサービスを提供しております。 企業イベント、お祭り、フェスティバル、学校行事など、さまざまなシーンに対応可能です。まずはお気軽にご相談ください。",
      phoneLabel: "電話",
      emailLabel: "メール",
      addressLabel: "住所",
      formHeading: "お問い合わせ",
      formDescription:
        "ぜひお気軽にご相談ください。お客様のニーズに合わせた最適なソリューションをご提案いたします。",
      namePlaceholder: "お名前",
      emailPlaceholder: "メールアドレス",
      phonePlaceholder: "電話番号",
      subjectPlaceholder: "件名",
      messagePlaceholder: "メッセージをご入力ください",
      submitting: "送信中...",
      submitRequest: "リクエストを送信",
      Getintouch: "連絡する",
      address:"〒300-0848 茨城県土浦市西根西1-2-21"
    },

    EventEnquiryContent: {
      heading: "イベントお問い合わせ",
      description:
        "イベントをスムーズに計画しましょう。ご要望をお聞かせいただければ、最適なお食事体験をご提案いたします。",
      restaurantLabel: "レストラン",
      selectRestaurant: "レストランを選択",
      nameLabel: "名前",
      namePlaceholder: "お名前を入力してください",
      phoneLabel: "電話番号",
      phonePlaceholder: "電話番号を入力してください",
      selectDateLabel: "日付を選択",
      selectTimeLabel: "時間を選択",
      numberOfGuestLabel: "ゲスト人数",
      specialRequestsLabel: "特別なご要望（任意）",
      specialRequestsPlaceholder:
        "食事制限や特別なご要望があればご記入ください。",
      submitting: "送信中...",
      submitEnquiry: "お問い合わせを送信",
      emailLabel: "メールアドレス",
      emailPlaceholder: "メールアドレスを入力してください",
      selectTableLabel: "テーブルを選択",
  selectTablePlaceholder: "-- テーブルを選択してください --",
  loadingTables: "テーブルを読み込み中...",
  noSlotAvailable: "空席がありません",
    },
    ReserveTableContent: {
      heading: "テーブルを予約する",
      description1: "お気に入りのレストランでテーブルを予約し、",
      description2:
        "を予約金として事前にお支払いいただけます。最終のお会計時に調整されます。",
      booking: "予約中...",
      confirmBooking: "予約を確定",
    },
    LoginContent: {
      heading: "ようこそ",
      brandName: "Ali’s Kebab",
      subHeading: "最高のサービスをご提供します",
      feature1: "安全で暗号化されたサインイン",
      feature2: "ダッシュボードへ素早くアクセス",
      feature3: "高品質なフードとケバブ",
    },
    CartPageContent: {
      applyCoupon: "クーポンを適用",
      enterCouponCode: "クーポンコードを入力",
      remove: "削除",
      apply: "適用",
      availableCoupons: "利用可能なクーポン",
      minCart: "最低注文金額:",
      expires: "有効期限:",
      notApplicable: "適用不可",
      subtotal: "小計",
      items: "商品",
      dealsOffers: "割引・特典",
      shipping: "配送料",
      tax: "税金",
      shippingTaxEstimated: "※配送料と税金はチェックアウト時に計算されます",
      estimatedTotal: "合計金額",
      proceedToCheckout: "チェックアウトへ進む",
      payWithStripe: "Squareで支払う",
      orderSummary: "注文概要",
      paymentOptions: "お支払い方法",
      orderFromDeliveryPartner: "デリバリーパートナーから注文",
      minimumOrderForDelivery: "デリバリーの最低注文金額:",
      pickup: "店頭受取",
      delivery: "デリバリー",
      orderType: "注文タイプ",
      orderrefund: "※ ご注文後の返金はできません。",
    },

    CheckoutFormContent: {
      continueShopping: "買い物を続ける",
      emailInfo: "ご注文の詳細や更新情報をこのメールアドレスにお送りします。",
      emailPlaceholder: "メールアドレスを入力してください",
      guestCheckout: "現在、ゲストとしてチェックアウトしています。",
      selectAddress: "住所を選択",
      addressLabel: "住所:",
      billingAddress: "請求先住所",
      yourDetails: "お客様情報",
      firstName: "名",
      lastName: "姓",
      phone: "電話番号",
      address: "住所",
      country: "国",
      city: "市区町村",
      state: "都道府県",
      zipCode: "郵便番号",
      shippingAddress: "配送先住所",
      sameAsBilling: "配送先住所は請求先住所と同じです。",
      email: "メールアドレス",
      addNote: "メモを追加",
      addNotePlaceholder: "注文に関するメモを追加してください",
    },
    PaymentFailedContent: {
      title: "お支払いに失敗しました！",
      description: "お支払いを処理できませんでした。",
      supportMessage: "お困りの場合は、サポートチームまでご連絡ください:",
    },
    PaymentSucessContent: {
      payment_success: "お支払い完了！",
      payment_success_msg:
        "お支払いが正常に処理されました。確認メールをまもなくお送りします。",
      transaction_id: "取引ID",
      date: "日付",
      transaction_type: "取引タイプ",
      status: "ステータス",
      success: "成功",
      total: "合計",
      receipt_sent: "領収書送信先",
      download_receipt: "領収書をダウンロード",
      downloading: "ダウンロード中...",
      continue_shopping: "買い物を続ける",
      support_text: "サポートが必要ですか までお問い合わせください。",
      date_time: "日時",
      restaurant: "レストラン",
      table_no: "テーブル番号",
      guests: "人数",
       payment_pending_title: "お支払いを処理中です",
        check_again: "再確認する",
  payment_pending_msg: "このページは自動的に更新されます。しばらくしてからご確認ください。",
  payment_failed_title: "支払いに失敗しました",
  payment_failed_msg: "もう一度お試しください。",
  back_to_menu: "メニューに戻る",
  payment_refunded_title: "返金されました",
  payment_refunded_msg: "この支払いは返金されました。",
  confirming_payment: "お支払いを確認しています…",
    },
    my_profile: "マイプロフィール",
    logout: "ログアウト",
    logout_confirm: "ログアウトしてもよろしいですか？",
    cancel: "キャンセル",
    discover_food_title: "近くの美味しい料理を見つけよう",
    discover_food_desc:
      "市内のレストランやフードトラックを探索しましょう。最寄りの店舗を見つけて、メニューを閲覧し、できたての美味しい料理をお楽しみください。",
    wishlist: "ウィッシュリスト",
    my_orders: "注文履歴",
    my_details: "プロフィール詳細",
    saving: "保存中...",
    save_changes: "変更を保存",
    select_title: "タイトルを選択",
    enter_name: "お名前を入力してください",
    enter_phone: "電話番号を入力してください",
    enter_email: "メールアドレスを入力してください",
    delete_account: "アカウント削除",
    delete_account_desc:
      "Ali’s Kebab のサービスが不要になった場合は、以下のボタンからアカウントを削除できます。ただし、進行中の注文、未払い、または配送処理中の内容がある場合、アカウントを削除することはできません。",
    delete_account_title: "アカウントを削除しますか？",
    delete_account_warning:
      "アカウントは完全に削除されます。この操作は元に戻せません。",
    confirm_delete_account: "はい、アカウントを削除します",
    no_wishlist_items: "ウィッシュリストに商品がありません",
    bentotitle: "美味しいハラール弁当のバリエーション",
    bentodes:
      "プレミアムハラールお弁当は本格ペルシャ・中東・インド料理を楽しめる特別なお弁当。イベントや会議などに対応し、内容や数量も柔軟にカスタマイズ可能です。",
    address: {
      my_address: "住所一覧",
      add_new_address: "新しい住所を追加",
      loading: "読み込み中...",
      no_address_found: "住所が見つかりません。",
      edit: "編集",
      delete: "削除",
      house_flat_number: "部屋番号 / 建物番号",
      building_society_name: "建物名 / 地域名",
      city: "市区町村",
      state: "都道府県",
      pincode_zipcode: "郵便番号",
      add_new_address_title: "新しい住所を追加",
      add_new_address_desc:
        "プロフィールに新しい住所を追加するため、以下の詳細情報をご入力ください。正確な情報を入力して、スムーズな配送と連絡を確保してください。",
      enter_name: "お名前を入力",
      phone: "電話番号",
      house_no: "建物番号",
      locality: "地域名",
      country: "国",
      zip_code: "郵便番号",
      select_type: "タイプを選択",
      home: "自宅",
      office: "オフィス",
      hotel: "ホテル",
      other: "その他",
      save_address: "住所を保存",
      saving: "保存中...",
      title: "本当によろしいですか？",
      text: "この住所は完全に削除されます。",
      confirm_button: "はい、削除します！",
      cancel_button: "キャンセル",
    },
    OrderContent: {
      my_orders: "注文履歴",
      search_food_restaurant: "料理またはレストランを検索...",
      zip_code: "郵便番号",
      search: "検索",
      loading_orders: "注文を読み込み中...",
      no_orders_found: "注文が見つかりません",
      order_item: "注文商品",
      subtotal: "小計",
      charges: "料金",
      total: "合計",
      date_time: "日時",
      order_status: "注文状況",
      discount: "割引",
      tax: "税金",
      shipping: "配送料",
      more_item: "件の商品を追加",
      base_price: "基本価格",
      qty: "数量",
      rate_item: "⭐ 商品を評価",
      prev: "← 前へ",
      next: "次へ →",
      rate_your_order: "注文を評価する",
      item: "商品",
      share_experience: "ご感想をお聞かせください",
      poor: "😞 良くない",
      okay: "😐 普通",
      good: "🙂 良い",
      very_good: "😊 とても良い",
      excellent: "😍 素晴らしい",
      share_experience_placeholder: "ご感想を入力してください...",
      submitting: "送信中...",
      submit_review: "レビューを送信",
    },
    OrderConfirmModal: {
      title: "ご注文の確認",
      orderingFrom: "ご注文は下記の店舗からです",
      locatedIn: "所在地",
      goBack: "戻る",
    
    },
     seo: {
    home: {
      title: "アリーズケバブ｜オンライン注文対応・本格トルコ＆ペルシャ料理",
      description: "アリーズケバブで本格トルコ・ペルシャ料理をオンライン注文。ケバブ、ラップ、ピザ、グリル料理を出来立てでご提供。テイクアウト・店内飲食対応",
    },
    about: {
      title: "Über uns | Ali's Kebab",
      description: "Erfahren Sie mehr über Ali's Kebab.",
    },
  },
  },
};
